import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { Reveal, Lines, SectionTag } from "../site/Motion";
import { IMG } from "../../lib/images";

export function TestDriveSection() {
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    navigate(`/test-drive${q.trim() ? `?q=${encodeURIComponent(q.trim())}` : ""}`);
  };

  return (
    <section id="test-drive" data-testid="testdrive-section" className="theme-dark relative overflow-hidden border-t border-white/10">
      <div className="absolute inset-0">
        <img src={IMG.testDrive} alt="Alla guida attraverso la città" className="h-full w-full object-cover opacity-35" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/60 to-ink" aria-hidden="true" />
      </div>
      <div className="relative mx-auto max-w-[1600px] px-5 py-28 sm:px-10 sm:py-40">
        <SectionTag index="13" label="Test drive" />
        <h2 className="mt-10 font-display font-extrabold uppercase leading-[0.92] tracking-tight">
          <Lines lines={["Don't just look.", "Drive it."]} stagger={0.15} className="text-4xl text-white sm:text-6xl lg:text-7xl" />
        </h2>
        <Reveal delay={0.25}>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-zinc-400">
            Le parole descrivono. La guida convince. Trova il centro SWAPA più vicino
            e prova SWAPA nella tua città.
          </p>
        </Reveal>
        <Reveal delay={0.35}>
          <form onSubmit={submit} className="mt-10 flex max-w-xl flex-col gap-3 sm:flex-row" role="search">
            <label className="relative flex-1">
              <MapPin className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-500" />
              <span className="sr-only">CAP o città</span>
              <input
                data-testid="testdrive-cap-input"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="CAP o città — es. 20121 o Milano"
                className="w-full border border-white/20 bg-black/50 py-4 pl-11 pr-4 font-mono text-sm text-white placeholder:text-zinc-600 backdrop-blur-sm focus:border-swapa-yellow focus:outline-none"
              />
            </label>
            <button
              type="submit"
              data-testid="testdrive-search-button"
              className="group inline-flex items-center justify-center gap-3 bg-swapa-yellow px-8 py-4 font-mono text-xs font-semibold uppercase tracking-[0.18em] text-black transition-transform duration-300 hover:-translate-y-0.5"
            >
              Trova il tuo test drive
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
